import { z } from "zod";
import { confirmableConfig, confirmableDefaults } from "./confirmable.js";
import { optionalUnlessRequired, type FieldDescriptor } from "./types.js";

const configSchema = z.object({
  ...confirmableConfig,
  min: z.number().optional(),
  max: z.number().optional(),
  precision: z.number().int().min(0).max(10).default(2),
});

export const decimalField: FieldDescriptor<z.infer<typeof configSchema>> = {
  type: "decimal",
  label: "Decimal",
  category: "number",
  icon: "Percent",
  configSchema,
  valueSchema: (config, isRequired) => {
    let schema = z.number({ invalid_type_error: "Enter a number" });
    if (config.min !== undefined) schema = schema.min(config.min);
    if (config.max !== undefined) schema = schema.max(config.max);

    const withPrecision = schema.refine((value) => {
      const decimals = (String(value).split(".")[1] ?? "").length;
      return decimals <= config.precision;
    }, `Use at most ${config.precision} decimal place(s)`);

    return optionalUnlessRequired(withPrecision, isRequired);
  },
  defaultConfig: { ...confirmableDefaults, precision: 2 },
  supportsProfileBinding: true,
  defaultSearchable: false,
  sortKind: "numeric",
  renderHints: {},
};
